import _ from 'lodash';

import DefaultCopy from './default-copy';

import DyzioTheme from './theme/dyzio';
import HitchTheme from './theme/hitch';
import DisruptTheme from './theme/disrupt';
import MarshallTheme from './theme/marshall';
import AddfluenceTheme from './theme/addfluence';
import VizzTheme from './theme/vizz';
import PgoneTheme from './theme/pgone';
import TravlrrTheme from './theme/travlrr';
import VoxogramTheme from './theme/voxogram';
import KinTheme from './theme/kin';
import BmbTheme from './theme/bmb';
import AfterpartyTheme from './theme/afterparty';
import GB42Theme from './theme/goblue42';
import DorchesterTheme from './theme/dorchester';
import CorqTheme from './theme/corq';
import CorqAgencyTheme from './theme/corq-agency';
import TheInfluencerTheme from './theme/the-influencer';
import SuforiaTheme from './theme/suforia';
import TheRoomTheme from './theme/theroom';
import StylistTheme from './theme/stylist';
import LacajaTheme from './theme/lacaja';
import CPATheme from './theme/crowdpointanalytics';
import ClimateCitizenTheme from './theme/climate-citizen';
import BdsTheme from './theme/bds';
import MarmaladeTheme from './theme/marmalade';
import InfluxerTheme from './theme/influxer';
import IncastTheme from './theme/incast';
import UploadTheme from './theme/upload';
import GiftaTheme from './theme/gifta';
import InSpaceTheme from './theme/inspace';
import MOITheme from './theme/moi';
import FLYTTheme from './theme/flyt';
import RightlanderTheme from './theme/rightlander';
import PulseTheme from './theme/pulse';
import InfluxcrowdTheme from './theme/influxcrowd';
import NTWTheme from './theme/ntw';
import StardustTheme from './theme/stardust';
import FreefolkTheme from './theme/freefolk';
import BroadwayTheme from './theme/broadway';
import MOONBOOTSTheme from './theme/moonboots';
import PARENTSTARSTheme from './theme/parentstars';
import GenfluencerTheme from './theme/genfluencer';
import MingoAppTheme from './theme/mingoapp';
import MecIncTheme from './theme/mecinc';
import SelectbrityTheme from './theme/selectbrity';
import SNACKDRAWERTheme from './theme/snackDrawer';
import AGENT99Theme from './theme/agent99';
import ROOMUNLOCKEDTheme from './theme/roomunlocked';
import GLOBALMEDIATheme from './theme/globalMedia';
import SENDYTheme from './theme/sendy';
import LINEUPTheme from './theme/lineup';
import SweatCoinTheme from './theme/sweatcoin';
import ABBOTTLYONTheme from './theme/abbottlyon';
import MonumentalTheme from './theme/monumental';
import KemosabeTheme from './theme/kemosabe';
import MsqsourceTheme from './theme/msqsource';
import ToptrumpsTheme from './theme/toptrumps';
import EmbellishedlondonTheme from './theme/embellishedlondon';
import THEINFLUENCROOMTheme from './theme/theinfluenceroom';

import NottingHillCompanyTheme from './theme/thenottinghillcompany';
import TrueStartTheme from './theme/truestart';
import WefluensTheme from './theme/wefluens';
import CaffeineBulletTheme from './theme/caffeine-bullet';
import UmbertoGianniniTheme from './theme/umberto-giannini';
import BoldAndGritTheme from './theme/bold-and-grit';
import ShopfluenceTheme from './theme/shopfluence';
import HerbalEssentialsTheme from './theme/herbalessentials';
import MotherCuppaTheme from './theme/mothercuppa';
import ElsasOrganicsTheme from './theme/elsas';
import MyotaTheme from './theme/myota';
import DogDynamicsTheme from './theme/dogdynamics';
import FierceLondonTheme from './theme/fiercelondon';
import ElemisTheme from './theme/elemis';
import StarboxTheme from './theme/starbox';
import SehoTheme from './theme/seho';
import CampfireTheme from './theme/campfire';
import ElemisMainTheme from './theme/elemis-main';
import RippleTheme from './theme/ripple';
import SandiTheme from './theme/sandi';
import DisoTheme from './theme/diso';

import EquiTheme from './theme/equi';
import GlazeTheme from './theme/glaze';
import AkaraTheme from './theme/akara';
import LunaTheme from './theme/luna';
import ChubbyTheme from './theme/chubby';

import DreamlabTheme from './theme/dreamlab';
import LangtonTheme from './theme/langton';
import PaddingtonTheme from './theme/paddington';
import BornNouliTheme from './theme/bornnouli';
import ShellRimulaTheme from './theme/shellrimula';
import WILDFUSIONTheme from './theme/wildfusion';
import PalomeTheme from './theme/palome';
import WRENTheme from './theme/wren';
import BevasTheme from './theme/bevas';
import DiemTheme from './theme/diem';

import UnderArmourTheme from './theme/underarmour';
import AllwynTheme from './theme/allwyn';
import NovaiTheme from './theme/novai';

import NLBeautyTheme from './theme/nl-beauty';

const DOMAIN_THEME_MAP = {
  'app.hitchesports.com': HitchTheme,
  'disrupt.dyzio.co': DisruptTheme,
  'marshall.dyzio.co': MarshallTheme,
  'addfluence.dyzio.co': AddfluenceTheme,
  'vizz.dyzio.co': VizzTheme,
  'data.vizz-agency.com': VizzTheme,
  'pgone.dyzio.co': PgoneTheme,
  'travlrr.dyzio.co': TravlrrTheme,
  'app.voxogram.com': VoxogramTheme,
  'data.kincommunity.com': KinTheme,
  'influencers.goblue42.com': GB42Theme,
  'blue42.dyzio.co': GB42Theme,
  'bmb.dyzio.co': BmbTheme,
  'corq.dyzio.co': CorqTheme,
  'data.corq.studio': CorqTheme,
  'creators.corq.studio': CorqAgencyTheme,
  'afterparty.dyzio.co': AfterpartyTheme,
  'creators.dorchestercollection.com': DorchesterTheme,
  'the-influencer.dyzio.co': TheInfluencerTheme,
  'data.theinfluencer.es': TheInfluencerTheme,
  'data.contentclub.es': TheInfluencerTheme,
  'data.suforia.com': SuforiaTheme,
  'campaigns.theroom.io': TheRoomTheme,
  'campaigns.stylist.co.uk': StylistTheme,
  'lacaja.dyzio.co': LacajaTheme,
  'cpa.dyzio.co': CPATheme,
  'tracking.crowdpointanalytics.com': CPATheme,
  'climate-citizen.dyzio.co': ClimateCitizenTheme,
  'influencers.climate-citizen.org': ClimateCitizenTheme,
  'bds.dyzio.co': BdsTheme,
  'brandfluencers.bdsmktg.com': BdsTheme,
  'marmalade.dyzio.co': MarmaladeTheme,
  'influxer.dyzio.co': InfluxerTheme,
  'creators.influxer.co.uk': InfluxerTheme,
  'incast.dyzio.co': IncastTheme,
  'influencers.incast.us': IncastTheme,
  'upload.dyzio.co': UploadTheme,
  'creators.uploadagency.com': UploadTheme,
  'gifta.dyzio.co': GiftaTheme,
  'influencers.gifta.co.uk': GiftaTheme,
  'influencers.inspace.asia': InSpaceTheme,
  'inspace.dyzio.co': InSpaceTheme,
  'moi.dyzio.co': MOITheme,
  'flyt.dyzio.co': FLYTTheme,
  'influencers.flytexperience.com': FLYTTheme,
  'rightlander.dyzio.co': RightlanderTheme,
  'pulse.dyzio.co': PulseTheme,
  'influencers.pulse.africa': PulseTheme,
  'influxcrowd.dyzio.co': InfluxcrowdTheme,
  'connect.influxcrowd.com': InfluxcrowdTheme,
  'ntw.dyzio.co': NTWTheme,
  'stardust.dyzio.co': StardustTheme,
  'freefolk.dyzio.co': FreefolkTheme,
  'collaborations.freefolkagency.com': FreefolkTheme,
  'collaborations.broadwaysocial.media': BroadwayTheme,
  'campaigns.mymoonboots.io': MOONBOOTSTheme,
  'broadway.dyzio.co': BroadwayTheme,
  'moonboots.dyzio.co': MOONBOOTSTheme,
  'parentstars.dyzio.co': PARENTSTARSTheme,
  'platform.parentstars.co.uk': PARENTSTARSTheme,
  'creators.genfluencer.io': GenfluencerTheme,
  'influencers.mingoapp.dk': MingoAppTheme,
  'creators.mecinc.gg': MecIncTheme,
  'selectbrity.dyzio.co': SelectbrityTheme,
  'creators.snackdrawer.com': SNACKDRAWERTheme,
  'attentionseeker.snackdrawer.com': SNACKDRAWERTheme,
  'agent99.dyzio.co': AGENT99Theme,
  'creators.roomunlocked.com': ROOMUNLOCKEDTheme,
  'creators.global-media.gr': GLOBALMEDIATheme,
  'senders.sendy.io': SENDYTheme,
  'lineup.dyzio.co': LINEUPTheme,
  'sweatcoin.dyzio.co': SweatCoinTheme,
  'collaborators.abbottlyon.com': ABBOTTLYONTheme,
  'abbottlyon.dyzio.co': ABBOTTLYONTheme,
  'creators.monumentalmarketing.co.uk': MonumentalTheme,
  'monumental.dyzio.co': MonumentalTheme,
  'kemosabe.dyzio.co': KemosabeTheme,
  'msqsource.dyzio.co': MsqsourceTheme,
  'toptrumps.dyzio.co': ToptrumpsTheme,
  'creators.toptrumps.com': ToptrumpsTheme,
  'embellishedlondon.dyzio.co': EmbellishedlondonTheme,
  'creators.embellishedlondon.com': EmbellishedlondonTheme,
  'creators.theinfluenceroom.com': THEINFLUENCROOMTheme,
  'thenottinghillcompany.shopfluence.app': NottingHillCompanyTheme,
  'truestart.shopfluence.app': TrueStartTheme,
  'creators.wefluens.com': WefluensTheme,
  'caffeinebullet.shopfluence.app': CaffeineBulletTheme,
  'umbertogiannini.shopfluence.app': UmbertoGianniniTheme,
  'boldandgrit.shopfluence.app': BoldAndGritTheme,
  'creators.shopfluence.app': ShopfluenceTheme,
  'herbalessentials.shopfluence.app': HerbalEssentialsTheme,
  'mothercuppa.shopfluence.app': MotherCuppaTheme,
  'elsasorganics.shopfluence.app': ElsasOrganicsTheme,
  'myota.shopfluence.app': MyotaTheme,
  'dogdynamics.shopfluence.app': DogDynamicsTheme,
  'fiercelondon.shopfluence.app': FierceLondonTheme,
  'elemis.shopfluence.app': ElemisTheme,
  'creators.starbox.co.uk': StarboxTheme,
  'get.seho.app': SehoTheme,
  'creators.campfire.co.uk': CampfireTheme,
  'creators.elemis.com': ElemisTheme,
  'equi.shopfluence.app': EquiTheme,
  'rippleco.shopfluence.app': RippleTheme,
  'ripple.shopfluence.app': RippleTheme,
  'sandi.shopfluence.app': SandiTheme,
  'diso.shopfluence.app': DisoTheme,
  'glaze.shopfluence.app': GlazeTheme,
  'akara.shopfluence.app': AkaraTheme,
  'luna.shopfluence.app': LunaTheme,
  'chubby.shopfluence.app': ChubbyTheme,
  'bevas.shopfluence.app': BevasTheme,
  'diem.shopfluence.app': DiemTheme,
  'sandi.dyzio.co': SandiTheme,
  'm3labscreators.msqpartners.com': MsqsourceTheme,
  'campaigns.langtonpr.com': LangtonTheme,
  'campaigns.dreamlabstudio.co.uk': DreamlabTheme,
  'paddington.shopfluence.app': PaddingtonTheme,
  'bornnouli.shopfluence.app': BornNouliTheme,
  'shellrimula.msqpartners.com': ShellRimulaTheme,
  'influencers.wildfusions.com': WILDFUSIONTheme,
  'creators.palome.com': PalomeTheme,
  'wren.dyzio.co': WRENTheme,
  'underarmour.dyzio.co': UnderArmourTheme,
  'allwyn.dyzio.co': AllwynTheme,
  'influencers.novaiinfluencer.ai': NovaiTheme,
  'nlbeauty.shopfluence.app': NLBeautyTheme,
};


const OVERRIDE = null;
const NO_OVERRIDE = null;
const OVERRIDE_THEME = process.env.NODE_ENV === 'production' ? NO_OVERRIDE : OVERRIDE;

const ThemeSelector = {
  theme: themeName => {
    if (OVERRIDE_THEME) {
      const copy = OVERRIDE_THEME
        ? { ...DefaultCopy, ...OVERRIDE_THEME.copy }
        : DefaultCopy;
      const theme = {
        ...(OVERRIDE_THEME || DyzioTheme),
        copy,
      };
      return theme;
    }
    const hostname = _.toLower(themeName || window.location.hostname);
    const copy = DOMAIN_THEME_MAP[hostname]
      ? { ...DefaultCopy, ...DOMAIN_THEME_MAP[hostname].copy }
      : DefaultCopy;
    const theme = {
      ...(DOMAIN_THEME_MAP[hostname] || DyzioTheme),
      copy,
    };
    return theme;
  },
  isWhiteLabel: () => {
    if (OVERRIDE_THEME) return true;

    const labels = _.keys(DOMAIN_THEME_MAP);
    const hostname = _.toLower(window.location.hostname);
    return _.includes(labels, hostname);
  },
  isFullWhiteLabel: () => _.get(ThemeSelector.theme(), 'isFullWhiteLabel', false),
  getAppTitle: () => _.get(ThemeSelector.theme(), 'title', 'dyzio'),
  getTermsAndConditionsLink: () => {
    const defaultLink = DyzioTheme.termsAndConditionsLink;
    return _.get(ThemeSelector.theme(), 'termsAndConditionsLink', defaultLink);
  },
  getInfluencerTermsAndConditionsLink: () => {
    const defaultLink = DyzioTheme.influencerTermsAndConditionsLink;
    const link = _.get(ThemeSelector.theme(), 'influencerTermsAndConditionsLink', defaultLink);
    return link;
  },
  isOverridden: () => OVERRIDE !== null,
};

export default ThemeSelector;



/** WEBPACK FOOTER **
 ** ./src/themes/theme-selector.js
 **/